module.exports = __webpack_public_path__ + "static/media/github.f76acfa8.png";